document.addEventListener("DOMContentLoaded", function() {
    /**
     * 1) Ottiene parametri URL (email, orderNumber) e li restituisce come oggetto.
     */
    function getQueryParams() {
        const params = new URLSearchParams(window.location.search);
        const email = params.get('email');
        const orderNumber = params.get('order_number');
        return { email, orderNumber };
    }

    /**
     * 2) Rimuove i parametri dalla query string e fa un reload della pagina
     */
    function removeQueryParams() {
        const url = new URL(window.location);
        url.searchParams.delete('email');
        url.searchParams.delete('order_number');
        window.history.replaceState(null, '', url.toString());
        window.location.reload();
    }

    /**
     * 3) Svuota il carrello.
     * Restituisce una Promise per poter concatenare il flusso con then/catch.
     */
    function clearCart() {
        return fetch(`${routes.cart_clear_url}`, { ...fetchConfig() })
            .then(response => response.text());
    }

    /**
     * 4) Verifica l'ordine su endpoint esterno (POST /verify_order)
     * Restituisce i dati in formato JSON
     */
    function verifyOrder(email, orderNumber) {
        return fetch('https://maseraticorsi.appshop.service.triboo.it/api/verify_order', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, order_number: orderNumber })
        }).then(response => response.json());
    }

    /**
     * 5) Aggiunge al carrello i prodotti gratuiti (free_products)
     *    Restituisce una Promise che si risolve dopo l'aggiunta al carrello.
     */
    function addFreeProductsToCart(freeProducts) {
        if (!freeProducts) {
            return Promise.resolve();
        }

        const items = [];
        Object.values(freeProducts).forEach(product => {
            product.variants.nodes.forEach(variant => {
                // Estrai ID numerico della variant
                const variantIdNumeric = variant.id.split('/').pop();
                // In questo esempio, aggiungiamo 1 come quantity
                items.push({
                    quantity: 1,
                    id: variantIdNumeric
                });
            });
        });

        if (!items.length) {
            return Promise.resolve();
        }

        return fetch(`${routes.cart_add_url}`, {
            ...fetchConfig('javascript'),
            body: JSON.stringify({ items })
        }).then(response => response.text());
    }

    /**
     * 6) Aggiorna il carrello con:
     *    - I custom_attributes provenienti da data.custom_attributes
     *    - I "participantData" che prima erano nelle line item properties
     *    - cart_guest_code = data.code
     */
    function updateCartAttributes(data) {
        // 6a) Partiamo dai custom_attributes esistenti nel JSON
        const attributesObject = (data.custom_attributes || []).reduce((acc, attr) => {
            acc[attr.key] = attr.value;
            return acc;
        }, {});

        // 6b) Per ogni prodotto gratuito, troviamo la line item corrispondente
        //     e recuperiamo i suoi customAttributes, aggiungendo:
        //     _product_title, _product_variant_title, _add_order_guests
        if (data.free_products) {
            Object.values(data.free_products).forEach(product => {
                // Ricavo il "nome" del prodotto sostituendo " - Free"
                const productName = product.title.replace(' - Free', '');

                product.variants.nodes.forEach(variant => {
                    // Trova la line item che ha come product.title = productName
                    const matchingLineItem = data.line_items.find(item => {
                        return item.node.product.title === productName;
                    });

                    if (matchingLineItem) {
                        // Estraggo alcuni dati dalla line item
                        const variantTitle = matchingLineItem.node.variantTitle;
                        const productTitle = matchingLineItem.node.product.title;

                        // Recupero i customAttributes della line item
                        const participantData = matchingLineItem.node.customAttributes.reduce((acc, attr) => {
                            acc[attr.key] = attr.value;
                            return acc;
                        }, {});

                        // Aggiungo i tre attributi che ti servono
                        participantData["_product_title"] = productTitle;
                        participantData["_product_variant_title"] = variantTitle;
                        participantData["_add_order_guests"] = "true";

                        // Merge di participantData dentro attributesObject
                        for (const [key, value] of Object.entries(participantData)) {
                            attributesObject[key] = value;
                        }
                    }
                });
            });
        }

        // 6c) Aggiungo il codice ospite come attributo di carrello
        attributesObject['cart_guest_code'] = data.code;

        return fetch(`${routes.cart_update_url}`, {
            ...fetchConfig('javascript'),
            body: JSON.stringify({ attributes: attributesObject })
        }).then(response => response.text());
    }

    /**
     * 7) Funzione principale che coordina il flusso:
     *    - Svuota il carrello
     *    - Verifica l'ordine
     *    - Aggiunge i prodotti gratuiti
     *    - Aggiorna gli attributi del carrello
     *    - Rimuove i parametri dalla URL
     */
    function processOrderFlow(email, orderNumber) {
        clearCart()
            .then(() => verifyOrder(email, orderNumber))
            .then(data => {
                // Prima aggiungo i prodotti gratuiti
                return addFreeProductsToCart(data.free_products)
                    .then(() => data); // Passo ancora 'data' per la promise chain
            })
            .then(data => {
                // Poi aggiorno il carrello con i custom_attributes + participantData
                return updateCartAttributes(data);
            })
            .then(() => {
                // Infine rimuovo i parametri dalla URL
                removeQueryParams();
            })
            .catch(err => {
                console.error('Errore nel flusso di elaborazione ordine:', err);
            });
    }

    // Avvio lo script solo se parametri email e orderNumber sono presenti
    const { email, orderNumber } = getQueryParams();
    if (email && orderNumber) {
        processOrderFlow(email, orderNumber);
    }
});
